import { render } from "./WalkthroughAdminPage.vue?vue&type=template&id=70124085&scoped=true"
import script from "./WalkthroughAdminPage.vue?vue&type=script&lang=js"
export * from "./WalkthroughAdminPage.vue?vue&type=script&lang=js"

import "./WalkthroughAdminPage.vue?vue&type=style&index=0&id=70124085&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70124085"]])

export default __exports__